const SensitiveWordManage = () =>
  import('@/views/main/inspect/sensitiveWordManage/SensitiveWordManage.vue')
export default {
  path: '/main/inspect/sensitiveWordManage',
  name: 'sensitiveWordManage',
  component: SensitiveWordManage,
  children: []
}